import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Hidden, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { countries } from 'countries-list';
import Localize from '../common/Localize';
import { DownloadLicenseButton } from '.';

class PaymentSystemsLicense extends React.Component {
    render() {
        const {
            name,
            department,
            email,
            country,
            state,
            city,
            password,
            since,
            till,
            systems,
        } = this.props;
        const { native, emoji } = countries[country] || { native: country, emoji: '' };
        return (
            <Paper>
                <Box mb={1} p={1} display='flex' width='100%'>
                    <Box width='100%'>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Grid item xs={4} sm={2} lg={3}>
                                    <FormattedMessage id='license.paymentSystems' defaultMessage='Payment systems' />
                                </Grid>
                                <Grid item xs={4} sm={3}>
                                    {name}
                                </Grid>
                                <Hidden xsDown>
                                    <Grid item sm={2}>
                                        <Typography color={new Date(till) > new Date() ? 'initial' : 'error'} variant='body2'>
                                            <FormattedDate
                                                value={till}
                                                year='numeric'
                                                month='numeric'
                                                day='numeric'
                                                minute='numeric'
                                                hour='numeric'
                                            />
                                        </Typography>
                                    </Grid>
                                </Hidden>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box width='100%'>
                                    {Array.isArray(systems) && systems.length !== 0 ?
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell padding='none'>
                                                        <FormattedMessage id='license.component' defaultMessage='Component' />
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {systems.map(name => (
                                                    <TableRow key={name} hover>
                                                        <TableCell padding='none'>
                                                            <Localize>
                                                                {name}
                                                            </Localize>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        : null
                                    }
                                    <Accordion>
                                        <AccordionSummary>
                                            <FormattedMessage id='license.details' defaultMessage='Details' />
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Table>
                                                <TableBody>
                                                    <TableRow hover>
                                                        <TableCell padding='none'>
                                                            <FormattedMessage id='license.created' defaultMessage='Created' />
                                                        </TableCell>
                                                        <TableCell padding='none'>
                                                            <FormattedDate
                                                                value={since}
                                                                year='numeric'
                                                                month='numeric'
                                                                day='numeric'
                                                                minute='numeric'
                                                                hour='numeric'
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow hover>
                                                        <TableCell padding='none'>
                                                            <Typography color={new Date(till) > new Date() ? 'initial' : 'error'} variant='body2'>
                                                                <FormattedMessage id='license.expirationDate' defaultMessage='Expiration date' />
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell padding='none'>
                                                            <Typography color={new Date(till) > new Date() ? 'initial' : 'error'} variant='body2'>
                                                                <FormattedDate
                                                                    value={till}
                                                                    year='numeric'
                                                                    month='numeric'
                                                                    day='numeric'
                                                                    minute='numeric'
                                                                    hour='numeric'
                                                                />
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow hover>
                                                        <TableCell padding='none'>
                                                            <FormattedMessage id='license.organization' defaultMessage='Organization' />
                                                        </TableCell>
                                                        <TableCell padding='none'>
                                                            {name}
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow hover>
                                                        <TableCell padding='none'>
                                                            <FormattedMessage id='license.department' defaultMessage='Department' />
                                                        </TableCell>
                                                        <TableCell padding='none'>
                                                            {department}
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow hover>
                                                        <TableCell padding='none'>
                                                            <FormattedMessage id='license.country' defaultMessage='Country' />
                                                        </TableCell>
                                                        <TableCell padding='none'>
                                                            {emoji} {native}
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow hover>
                                                        <TableCell padding='none'>
                                                            <FormattedMessage id='license.region' defaultMessage='Region' />
                                                        </TableCell>
                                                        <TableCell padding='none'>
                                                            {state}
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow hover>
                                                        <TableCell padding='none'>
                                                            <FormattedMessage id='license.city' defaultMessage='City' />
                                                        </TableCell>
                                                        <TableCell padding='none'>
                                                            {city}
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow hover>
                                                        <TableCell padding='none'>
                                                            <FormattedMessage id='license.email' defaultMessage='Email' />
                                                        </TableCell>
                                                        <TableCell padding='none'>
                                                            {email}
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow hover>
                                                        <TableCell padding='none'>
                                                            <FormattedMessage id='license.privateKeyPassword' defaultMessage='Private key password' />
                                                        </TableCell>
                                                        <TableCell padding='none'>
                                                            {password}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                    <Box display='flex' flexWrap='nowrap' alignItems='center' mr={1}>
                        <DownloadLicenseButton type='payment_systems' />
                    </Box>
                </Box>
            </Paper>

        );
    }
}

export default PaymentSystemsLicense;
